import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Swords } from "lucide-react";
import { Switch } from "../ui/switch";
import { api, errMessage } from "../../lib/api";

const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

// Boss Battle reminder preferences: parents can turn the weekly "boss is
// ready" email off, or pick which weekday it arrives (default Monday).
export const BossReminderControls = () => {
  const [enabled, setEnabled] = useState(null);
  const [day, setDay] = useState(0);

  useEffect(() => {
    api.get("/recap/boss-reminder")
      .then(({ data }) => { setEnabled(data.enabled); setDay(data.day ?? 0); })
      .catch(() => setEnabled(false));
  }, []);

  const save = async (nextEnabled, nextDay) => {
    const prev = { enabled, day };
    setEnabled(nextEnabled);
    setDay(nextDay);
    try {
      await api.put("/recap/boss-reminder", { enabled: nextEnabled, day: nextDay });
      toast.success(nextEnabled
        ? `Boss Battle reminder on — arrives ${DAYS[nextDay]}s`
        : "Boss Battle reminder turned off");
    } catch (e) {
      setEnabled(prev.enabled);
      setDay(prev.day);
      toast.error(errMessage(e));
    }
  };

  return (
    <div className="bg-card rounded-2xl border border-border p-5 flex flex-wrap items-center justify-between gap-4" data-testid="boss-reminder-controls">
      <div className="flex items-center gap-3">
        <Swords className="h-5 w-5 text-secondary" aria-hidden="true" />
        <div>
          <p className="text-sm font-semibold">Boss Battle reminder</p>
          <p className="text-xs text-muted-foreground">A weekly heads-up email when your child's Boss Battle is unlocked but not yet played.</p>
        </div>
      </div>
      <div className="flex items-center gap-3">
        {enabled === null ? (
          <span className="text-xs text-muted-foreground" data-testid="boss-reminder-loading">Loading…</span>
        ) : (
          <>
            <select value={String(day)} disabled={!enabled}
              onChange={(e) => save(enabled, Number(e.target.value))}
              className="h-8 rounded-lg border border-border bg-card px-2 text-xs disabled:opacity-50"
              aria-label="Boss reminder day" data-testid="boss-reminder-day-select">
              {DAYS.map((d, i) => <option key={d} value={i}>{`${d}s`}</option>)}
            </select>
            <Switch checked={Boolean(enabled)} onCheckedChange={(v) => save(Boolean(v), day)}
              aria-label="Boss Battle reminder" data-testid="boss-reminder-toggle" />
          </>
        )}
      </div>
    </div>
  );
};
